export enum AssignmentAttemptActionType {
  GET_ASSIGNMENT_ATTEMPT_REQUEST_SUCCESS = 'ASSIGNMENT_ATTEMPT.GET_ASSIGNMENT_ATTEMPT_REQUEST_SUCCESS',
  CREATE_MESSAGE_REQUEST_SUCCESS = 'ASSIGNMENT_ATTEMPT.CREATE_MESSAGE_REQUEST_SUCCESS',
  READ_MESSAGES_REQUEST_SUCCESS = 'ASSIGNMENT_ATTEMPT.READ_MESSAGES_REQUEST_SUCCESS'
}
